import { PropTypes } from 'prop-types';
import { useState } from 'react';

import '../../DrilldownAndDetailSearch.css';

import { CircularProgress } from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getDrilldownParentDisplayLabel } from '@/common/utils/DrilldownDisplayUtils';
import { trI18n } from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { getPublicAPI } from '@/service/publicService';
import DrilldownTreeItem from './DrilldownTreeItem';
import { isSelectedOption, selectDrilldown } from '../../handler/DrilldownAndDetailSearchHandler';


const RenderDrilldownTag = ({tagItem, argsCommon}) => {
    // trLabel()/trI18n() read a plain Map; this is what re-renders the tree when
    // the dictionary is loaded or extended.
    useTranslationSubscription();

    const [isLoadingChild, setIsLoadingChild] = useState(false)
    const [tagChild, setTagChid] = useState([...tagItem?.child] || []);

    const handleToggle = async () => {
        if (!Utils.isEmptyArray(tagChild)) return;
        setIsLoadingChild(true);
        const params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.DRILLDOWN_GET_TAG_CHILD,
            getItem: tagItem,
            limit: Constant.DEFAULT_TAGS_VISIBLE_COUNT
        };

        getPublicAPI(null, params)
            .then(res => {
                const itemListData = Utils.convertJSONDataToObject(res?.payload)?.itemListData || [];
                if (!Utils.isEmptyArray(itemListData)) {
                    // setTagChid(prev => [...prev, ...itemListData]);
                    setTagChid([...itemListData]);
                }
            })
            .catch(err => console.log('getTagChild handleToggle err >>> ', err))
            .finally(() => setIsLoadingChild(false));
    };

    const handleSeeMore = async() => {
        setIsLoadingChild(true);

        const params = {
            getApiType: Constant.GET_API_PUBLIC_TYPE.DRILLDOWN_GET_TAG_CHILD,
            getItem: tagItem,
            limit: Constant.DEFAULT_TAGS_VISIBLE_COUNT,
            lastItem: tagChild[tagChild.length - 1]
        };

        getPublicAPI(null, params)
            .then(res => {
                const itemListData = Utils.convertJSONDataToObject(res?.payload)?.itemListData || [];
                if (!Utils.isEmptyArray(itemListData)) {
                    setTagChid(prev => [...prev, ...itemListData]);
                }
            })
            .catch(err => console.log('getTagChild handleLoadMoreTag err >>> ', err))
            .finally(() => setIsLoadingChild(false));
    }

    const handleSeeLess = () => {
        if (tagItem.itemListTotal !== tagChild.length || tagChild.length <= Constant.DEFAULT_TAGS_VISIBLE_COUNT) return;
        setTagChid(prev => [...prev].slice(0, Constant.DEFAULT_TAGS_VISIBLE_COUNT))
    }

    if (tagItem.sysField === Constant.SYSTEM_FIELD.BUSINESS_APP_USE_RANGE) {
        let childInOrg = [];
        let childTagItem = [];
        let countChildInOrg = 0;
        let countChildTagItem = 0;
        let selectedChildId = [];
        if (!Utils.isEmptyArray(argsCommon?.viewStructure?.tagFields)) {
            for (const field of argsCommon?.viewStructure?.tagFields) {
                if (field && field.hasOwnProperty(tagItem.id)) {
                    selectedChildId.push(field[tagItem.id]);
                }
            }
        }

        if (!Utils.isEmptyArray(tagItem?.child)) {
            for (const childData of tagItem?.child) {
                if (childData?.type === Constant.DRILLDOWN_TAG_ITEM_TYPE.PROJECT && !selectedChildId.includes(childData.id)) {
                    countChildInOrg += parseInt(childData?.total) || 0;
                    childInOrg.push(childData);
                }
                if (childData?.type === Constant.DRILLDOWN_TAG_ITEM_TYPE.TAG_FIELD && !selectedChildId.includes(childData.id)) {
                    countChildTagItem += parseInt(childData?.total) || 0;
                    childTagItem.push(childData);
                }
            }
        }

        const groupInOrgLabel = trI18n('USER04BTN007');
        const groupTagItemLabel = trI18n('LABEL-OTHERS');
        const labelGroupChildInOrg = countChildInOrg ? `${groupInOrgLabel} (${countChildInOrg})` : groupInOrgLabel;
        const labelGroupChildTagItem = countChildTagItem ? `${groupTagItemLabel} (${countChildTagItem})` : groupTagItemLabel;

        return (
            <TreeView
                key={tagItem.id}
                onNodeToggle={handleToggle}
                defaultCollapseIcon={<ArrowDropDownIcon />}
                defaultExpandIcon={<ArrowRightIcon />}
            >
                <TreeItem
                    nodeId={tagItem.id}
                    label={`${getDrilldownParentDisplayLabel(tagItem)} ${tagItem.total ? '(' + tagItem.total + ')' : ''}`}
                    disableselection="true"
                >
                    {!Utils.isEmptyArray(childInOrg) && (
                        <TreeItem
                            nodeId={tagItem.id + '-childInOrg'}
                            label={labelGroupChildInOrg}
                            disableselection="true"
                        >
                            {childInOrg.map(child => (
                                <DrilldownTreeItem
                                    itemChild={child}
                                    argsCommon={argsCommon}
                                    item={tagItem}
                                    selectDrilldown={selectDrilldown}
                                />
                            ))}
                        </TreeItem>
                    )}

                    {!Utils.isEmptyArray(childTagItem) && (
                        <TreeItem
                            nodeId={tagItem.id + '-childTagItem'}
                            label={labelGroupChildTagItem}
                            disableselection="true"
                        >
                            {childTagItem.map(child => (
                                <DrilldownTreeItem
                                    itemChild={child}
                                    argsCommon={argsCommon}
                                    item={tagItem}
                                    selectDrilldown={selectDrilldown}
                                />
                            ))}
                        </TreeItem>
                    )}
                </TreeItem>
            </TreeView>
        );
    }

    return (
        <TreeView
            key={tagItem.id}
            onNodeToggle={handleToggle}
            defaultCollapseIcon={<ArrowDropDownIcon />}
            defaultExpandIcon={<ArrowRightIcon />}
        >
            <TreeItem
                nodeId={tagItem.id}
                label={`${getDrilldownParentDisplayLabel(tagItem)} ${
                    tagItem.total ? '(' + tagItem.total + ')' : ''
                }`}
                disableselection="true"
            >
                {!Utils.isEmptyArray(tagChild) && tagChild.map(child => {
                    if (isSelectedOption(argsCommon?.viewStructure, tagItem, child.id)) {
                        return null;
                    }

                    return (
                        <DrilldownTreeItem
                           itemChild={child}
                           argsCommon={argsCommon}
                           item={tagItem}
                           selectDrilldown={selectDrilldown}
                        />
                    )
                })}
                {isLoadingChild && (
                    <div style={{marginTop: '5px'}}><CircularProgress color="primary" size="1rem"/></div>
                )}
                {!isLoadingChild && tagItem.itemListTotal > tagChild.length && (
                    <button
                        className="showMore-btn-drilldown"
                        onClick={handleSeeMore}
                    >
                        {trI18n('COMBTN009')}
                    </button>
                )}
                {tagItem.itemListTotal === tagChild.length && tagChild.length > Constant.DEFAULT_TAGS_VISIBLE_COUNT && (
                    <button
                        className="showMore-btn-drilldown"
                        onClick={handleSeeLess}
                    >
                        {trI18n('COMBTN010')}
                    </button>
                )}
            </TreeItem>
        </TreeView>
    )
}

RenderDrilldownTag.prototype = {
    tagItem: PropTypes.any,
    argsCommon: PropTypes.any,
}

export default RenderDrilldownTag;